__turbopack_context__.v({
  "ManualSection": "zJq8eq_ManualSection",
  "ManualSection--WithLine": "zJq8eq_ManualSection--WithLine",
  "ManualSection__Title": "zJq8eq_ManualSection__Title",
});
